import type { ScenePreset } from "@cfg/brand-sdk";
import { absMaterial } from "./abs.ts";

/**
 * Brick plastic on graph paper, after the LEGO Movie: glossy moulded ABS (see
 * abs.ts) in a small photo studio. The lightformers give the coat something
 * to reflect: a big overhead softbox, two vertical strips that draw the
 * crisp edge highlights, a back rim and a warm bounce from the paper. Direct
 * lights stay moderate since the environment already fills the shadows.
 * Grid is the 8 mm stud pitch.
 */
export const ledger: ScenePreset = {
  id: "ledger",
  material: ({ three, color }) => absMaterial(three, { color }),
  environment: {
    intensity: 0.6,
    lightformers: [
      { form: "rect", intensity: 7, color: "#fff6ea", position: [-2, -3, 10], scale: [6, 8] },
      { form: "rect", intensity: 14, color: "#ffffff", position: [-7, -6, 3], scale: [2, 9] },
      { form: "rect", intensity: 9, color: "#e8f0ff", position: [8, -2, 2], scale: [1.5, 7] },
      { form: "rect", intensity: 8, color: "#ffffff", position: [0, 9, 4], scale: [10, 2] },
      { form: "rect", intensity: 0.8, color: "#f2eee1", position: [0, 0, -8], scale: [16, 16] },
    ],
  },
  lights: {
    ambient: 0.05,
    hemisphere: { sky: "#f7f4ec", ground: "#c3cfdc", intensity: 0.2 },
    key: { intensity: 1.4, position: [80, -120, 160], color: "#fff4e6", castShadow: true },
    fill: { intensity: 0.45, position: [-140, -60, 80], color: "#dfe9f5" },
    rim: { intensity: 0.6, position: [40, 160, 120], color: "#ffffff" },
  },
  background: "#f2eee1",
  grid: { show: true, cellSize: 8, sectionSize: 40, color: "#d8e0e8", sectionColor: "#c3cfdc", infinite: true },
  shadows: true,
  toneMapping: "Neutral",
  exposure: 1.0,
  camera: { fov: 32, distanceFactor: 1.2, autoRotate: 0 },
};
